import React, { useContext, useState } from "react";
import { useMutation } from "@tanstack/react-query";

//App
import { SettingFormContainerProps } from "../../../types/setting";
import { SnackbarState } from "../../../types";
import { SettingDto } from "../../../app/model/api/types/dto/settingDto";
import settingApi from "../../../app/model/api/settingApi";
import { apiErrorMessage } from "../../../utility/lib/error";
import { SettingContext } from "./SettingsContainer";
import { EMPTY_GUID } from "../../../utility/constants/constants";
import SettingForm from "./SettingForm";

//Common
import {
    Snackbar
} from "../../common/VFX-UI";
import { SettingViewModel } from "../../../viewModels/settingViewModel";

export const SettingFormContainer: React.FC<
  SettingFormContainerProps
> = (props) => {
  const { onClose, onShowSuccess } = props;
  const settingContext = useContext(SettingContext);

  const [snackbar, setSnackbar] = useState<SnackbarState>({
    showErrorSnackbar: false,
    errorMessage: "",
  });

  const successMessage = settingContext?.id
    ? "Setting updated"
    : "New Setting added";

  const onShowErrorSnackbar = (errorMessage: string) => {
    setSnackbar({
      showErrorSnackbar: true,
      errorMessage,
    });
  };

  const onCloseSnackbar = () => {
    setSnackbar({
      showErrorSnackbar: false,
      errorMessage: "",
    });
  };

  const { status, mutate } = useMutation<void, Error, SettingDto>({
      mutationFn: async (payload: SettingDto) => {
      const response = await settingApi.save(payload);
      const errorMessage = apiErrorMessage(response.errorMessages);
      if (errorMessage) {
        onShowErrorSnackbar(errorMessage);
      } else {
        onShowSuccess(successMessage);
      }
    },
    onError: () => console.log("error"),
    onSuccess: () => console.log("success"),
  });

  const handleOnSubmit = async (values: SettingViewModel) => {
    const setting: SettingDto = values.toDto();
      mutate(setting);
  };

    const initialValues = settingContext?.id
    ? new SettingViewModel(
        settingContext?.data?.id ?? null,
        settingContext?.data?.name ?? null,
        settingContext?.data?.description ?? null,
        settingContext?.data?.sortValue ?? null,
        settingContext?.data?.isActive ?? null,
        settingContext?.data?.code ?? null,
        settingContext?.data?.enumName ?? null,
        settingContext?.data?.value ?? null,
      )
    : new SettingViewModel(EMPTY_GUID, "", "", 1, true, "" , "", "");

  return (
    <>
      <SettingForm
        initialVal={initialValues}
        status={status}
        handleOnSubmit={handleOnSubmit}
        onClose={onClose}
      />
      {snackbar.showErrorSnackbar && (
        <Snackbar
          open={true}
          message={snackbar.errorMessage}
          handleClose={onCloseSnackbar}
          severity="danger"
        />
      )}
    </>
  );
};
